export default __webpack_public_path__ + "static/media/Spa_And_Massage.a6a922d0.svg";